module.exports = __webpack_public_path__ + "img/ic04.942d9209.png";